jQuery( function( $ ) {
	if ( ( 0 < $( '.parallax-container' ).length ) && ( 992 < $( window ).width() ) ) {
		$( document ).ready( function( ) {
			window.scrollTo( window.scrollX, window.scrollY + 1 );
		} );

		window.addEventListener( 'scroll', function( ) {
			const topDistance = $( '.parallax-container' ).offset().top - this.pageYOffset;
			const layers = document.querySelectorAll( "[data-type='parallax']" );
			for ( let i = 0; i < layers.length; i++ ) {
				const layer = layers[ i ];
				const depth = layer.getAttribute( 'data-depth' );
				let sum = topDistance * depth;

				if ( -300 > sum ) {
					sum = -300;
				}

				if ( 0 === i && 100 < sum ) {
					sum = 100;
				}

				if ( 2 === i && 120 < sum ) {
					sum = 120;
				}

				if ( 3 === i && -285 > sum ) {
					sum = -285;
				}

				if ( 4 === i && 310 < sum ) {
					sum = 310;
				}

				const translate3d = 'translate3d(0, ' + -( sum ) + 'px, 0)';
				layer.style[ '-webkit-transform' ] = translate3d;
				layer.style[ '-moz-transform' ] = translate3d;
				layer.style[ '-ms-transform' ] = translate3d;
				layer.style[ '-o-transform' ] = translate3d;
				layer.style.transform = translate3d;
			}
		} );
	}
} );
